// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1sLed","requiredAsterisk":"Info_requiredAsterisk__2Tps_"};